export const itData = `
  <div class="paragraph">
    <div class="page-title">Domande frequenti sul programma di permuta (Trade-In)</div>
  </div>
  <div class="paragraph">
    <div class="title">Chi può partecipare al programma di permuta?</div>
    <div class="text-box">
      <div class="text">
        Il Servizio di permuta è disponibile esclusivamente per le persone fisiche di età pari o superiore a 18 anni che risiedono legalmente in uno Stato membro dell’Unione Europea, con esclusione delle Isole Canarie, delle Isole Baleari, di Ceuta e Melilla.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa devo fare prima di inviare il mio vecchio dispositivo?</div>
    <div class="text-box">
      <div class="text">
        Prima di inviare il dispositivo:<br>
        •	Cancella tutti i dati personali e rimuovi eventuali PIN, password o blocchi schermo.<br>
        •	Esegui un ripristino completo alle impostazioni di fabbrica.<br>
        •	Su iPhone: disconnetti il tuo account iCloud disattivando "Dov’è il mio iPhone".<br>
        •	Su Android: rimuovi il tuo account Google (Impostazioni > Account > Google > Rimuovi account).<br>
        •	Per le action camera: rimuovere eventuali account collegati, eliminare tutti i file multimediali, formattare la scheda di memoria (se applicabile) ed eseguire un ripristino completo alle impostazioni di fabbrica.<br>
        In questo modo garantisci che il dispositivo non sia più collegato al tuo account e proteggi le tue informazioni personali.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Come posso inviare il mio vecchio dispositivo?</div>
    <div class="text-box">
      <div class="text">
        <strong>Imballaggio:</strong> utilizza una scatola robusta e opaca (non trasparente) e aggiungi una protezione interna (come pluriball o simili) per evitare danni durante il trasporto.<br>
        <strong>Materiali di imballaggio:</strong> se non disponi del materiale di imballaggio adeguato, puoi richiederlo presso il punto di consegna quando lasci il pacco.<br>
        <strong>Documentazione:</strong> stampa, compila e firma la Dichiarazione di Onestà, quindi inseriscila nel pacco prima di sigillarlo.<br>
        <strong>Chiusura sicura:</strong> assicurati che il pacco sia ben chiuso e applica l’etichetta di spedizione gratuita in un punto ben visibile.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quali tipi di dispositivi non sono accettati?</div>
    <div class="text-box">
      <div class="text">
        Non accettiamo dispositivi che:<br>
        •	siano bloccati da operatore (SIM-lock);<br>
        •	non si accendano o non si ricarichino;<br>
        •	non possano connettersi tramite Bluetooth o Wi-Fi;<br>
        •	presentino guasti ai componenti interni o alla scheda madre;<br>
        •	non possano scattare foto o registrare video correttamente;<br>
        •	abbiano lenti incrinate o danni strutturali gravi;<br>
        •	presentino pulsanti malfunzionanti o problemi di stabilizzazione;<br>
        •	siano stati esposti a liquidi o riparati/smontati;<br>
        •	siano ancora collegati a iCloud, Google o a qualsiasi account utente;<br>
        •	siano contraffatti o repliche;<br>
        •	siano gravemente danneggiati.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Devo inviare anche gli accessori (caricatore, cavo, ecc.)?</div>
    <div class="text-box">
      <div class="text">
        Non è obbligatorio, ma è consigliato. Includere gli accessori contribuisce alla sostenibilità e al corretto riutilizzo del dispositivo.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Devo inviare anche gli auricolari?</div>
    <div class="text-box">
      <div class="text">
        No. Per motivi igienici, gli auricolari verranno eliminati e non saranno inclusi nella valutazione.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Devo inviare la fattura di acquisto?</div>
    <div class="text-box">
      <div class="text">
        No, non è necessaria per la valutazione o per il pagamento. Puoi conservarla per i tuoi archivi personali.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Come viene valutato il mio vecchio dispositivo?</div>
    <div class="text-box">
      <div class="text">
        Utilizziamo un software di diagnostica certificato e svolgiamo un’ispezione manuale nel nostro centro di valutazione per determinare le condizioni del tuo dispositivo. Tutte le procedure di valutazione e di gestione dei dati sono conformi al Regolamento generale sulla protezione dei dati (GDPR – UE 2016/679), garantendo la sicurezza e la riservatezza delle informazioni.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se lo stato che ho indicato non corrisponde alla vostra valutazione?</div>
    <div class="text-box">
      <div class="text">
        Se esistono differenze tra lo stato dichiarato e la nostra valutazione, ti invieremo un’e-mail contenente:<br>
        •	<strong>Un’offerta aggiornata</strong> basata sull’ispezione effettiva.<br>
        •	<strong>Il rapporto diagnostico</strong> e le motivazioni della differenza riscontrata.<br><br>
        Puoi scegliere di accettare o rifiutare l’offerta:<br>
        •	Se accetti, la permuta sarà completata e riceverai il pagamento sul tuo conto bancario entro 3 giorni lavorativi.<br>
        •	Se rifiuti, il processo di restituzione dipenderà dalla tua posizione:<br>
        &nbsp;&nbsp;•	Per tutti i clienti si applica una tariffa di restituzione fino a un massimo di 22 € (IVA inclusa).<br>
        &nbsp;&nbsp;•	L’importo dovrà essere versato entro cinque (5) giorni di calendario dalla ricezione della richiesta di pagamento, utilizzando l’etichetta ufficiale di reso prepagata fornita da Danghuan.<br>
        &nbsp;&nbsp;•	I dettagli di pagamento saranno forniti su richiesta o inclusi nell’e-mail contenente il link di pagamento.<br>
        &nbsp;&nbsp;•	Una volta confermato il pagamento, Danghuan verificherà la transazione entro cinque (5) giorni lavorativi e organizzerà la spedizione di restituzione all’indirizzo originale. Il cliente sarà informato via e-mail una volta effettuata la spedizione, comprensiva delle informazioni di tracciamento.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se non rispondo all’offerta aggiornata?</div>
    <div class="text-box">
      <div class="text">
        In assenza di risposta entro cinque (5) giorni di calendario dalla data di notifica, l’offerta revisionata si intenderà automaticamente accettata, senza ulteriore notifica, sollecito o comunicazione da parte di Danghuan.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa accade ai miei dati personali?</div>
    <div class="text-box">
      <div class="text">
        Devi eliminare tutti i dati prima di inviare il dispositivo. Se rileviamo dati residui, sospenderemo il processo e ti contatteremo per rimuoverli. Rispettiamo pienamente il GDPR (Regolamento UE 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Chi paga le spese di spedizione?</div>
    <div class="text-box">
      <div class="text">
        La prima spedizione è sempre gratuita.<br><br>
        Se rifiuti l’offerta aggiornata:<br>
        •	Per tutti i clienti si applica una tariffa di restituzione fino a un massimo di 22 € (IVA inclusa).<br>
        •	L’importo dovrà essere versato entro cinque (5) giorni di calendario dalla ricezione della richiesta di pagamento, utilizzando l’etichetta ufficiale di reso prepagata fornita da Danghuan.<br>
        •	I dettagli di pagamento saranno forniti su richiesta o inclusi nell’e-mail contenente il link di pagamento.<br>
        •	Una volta confermato il pagamento (se applicabile), Danghuan verificherà la transazione entro 5 giorni lavorativi e organizzerà la spedizione di ritorno all’indirizzo originale.Riceverai un’e-mail di notifica quando il pacco sarà spedito, con le relative informazioni di tracciamento.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Cosa succede se il mio pacco viene smarrito durante la spedizione?</div>
    <div class="text-box">
      <div class="text">
        Se il tuo dispositivo viene smarrito durante il trasporto, Danghuan Europe S.L. ti assisterà nella procedura ufficiale di reclamo con il corriere.<br><br>
        Una spedizione è considerata smarrita se non è stata tracciata, confermata o ricevuta da Danghuan entro 15 giorni di calendario dalla consegna al corriere.<br><br>
        •	Devi utilizzare l’etichetta di spedizione prepagata autorizzata da Danghuan; l’utilizzo di qualsiasi altro metodo annullerà la copertura per smarrimento.<br>
        •	I reclami per UPS devono essere presentati entro 60 giorni dalla creazione dell’etichetta.<br>
        •	Per le spedizioni tramite CORREOS (Spagna), i reclami devono essere presentati il prima possibile, preferibilmente entro 15 giorni, e non oltre 1 anno dalla data di spedizione.<br>
        •	Danghuan assisterà il corriere durante l’indagine, che di solito dura da 30 a 60 giorni.<br><br>
        Se lo smarrimento è confermato nel sistema logistico di Danghuan e l’etichetta autorizzata è stata utilizzata, il risarcimento non supererà il valore finale stimato di permuta del dispositivo.<br><br>
        I pagamenti approvati saranno trasferiti direttamente all’IBAN fornito durante la registrazione.<br><br>
        <em>Nota: qualsiasi risarcimento dipende dalla politica del corriere.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quando riceverò il pagamento?</div>
    <div class="text-box">
      <div class="text">
        Una volta accettata l’offerta finale, il pagamento verrà effettuato tramite bonifico bancario entro 3 giorni lavorativi. Assicurati che il tuo IBAN e il tuo Numero di identificazione personale siano corretti e corrispondano al titolare del conto.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">È obbligatorio fornire il mio Numero di identificazione personale?</div>
    <div class="text-box">
      <div class="text">
        Sì. Per elaborare il pagamento, devi fornire un Numero di identificazione personale valido, senza spazi o caratteri speciali, che corrisponda al titolare dell’IBAN.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Posso annullare la mia operazione di permuta?</div>
    <div class="text-box">
      <div class="text">
        Sì, se il tuo vecchio dispositivo non è ancora stato pagato.Ti preghiamo di contattarci il prima possibile all’indirizzo insta360@danghuan.eu. Se hai già inviato il dispositivo, contattaci entro 48 ore; in caso contrario, il processo di riciclaggio procederà normalmente.
      </div>
    </div>
  </div>
`;